<template>
  <div>
    <vxe-toolbar
      id="toolbarId_bak"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button
          v-if="getLimit('MerchantCenter_search_button')"
          @click="funcFilter()"
          >查询</el-button
        >
        <el-button
          v-if="getLimit('MerchantCenter_Add_button')"
          @click="onShowModel(false, 'Add')"
          >新增</el-button
        >
        <el-button
          v-if="getLimit('MerchantCenter_export_button')"
          @click="funcExport()"
        >
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      show-footer
      highlight-hover-row
      row-id="id"
      height="700"
      :data="tableData"
      :loading="loading"
      sort-config.remote
      export-config
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column>
        <vxe-table-column
          field="branchCode"
          title="承运主体"
          :formatter="formatterBranch"
          min-width="150"
          sortable
          sort-config.remote
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.branchCode"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in branchList"
              :key="item.code"
              :label="item.groupName"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="partyType"
          min-width="140"
          title="用户类型"
          :formatter="
            ({ cellValue }) => formatterField({ cellValue }, 'partyType')
          "
          sort-config.remote
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.partyType"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in parentData.partyTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="name"
          title="用户名称"
          min-width="130"
          sortable
          sort-config.remote
        />
        <template v-slot:header>
          <el-input v-model="listQuery.name" placeholder="请输入" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="phone"
          title="用户电话"
          min-width="130"
          sortable
          sort-config.remote
        />
        <template v-slot:header>
          <el-input v-model="listQuery.phone" placeholder="请输入" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="accountId"
          title="商户id"
          min-width="180"
          sortable
          sort-config.remote
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.accountId"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="merchantType"
          :formatter="
            ({ cellValue }) => formatterField({ cellValue }, 'merchantType')
          "
          title="商户类型"
          min-width="100"
          sortable
          sort-config.remote
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.merchantType"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in parentData.merchantTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="merchantName"
          title="商户名称"
          min-width="200"
          sortable
          sort-config.remote
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.merchantName"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="merchantShortName"
          title="商户简称"
          min-width="200"
          sortable
          sort-config.remote
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.merchantShortName"
            placeholder="请输入"
            clearable
            sort-config.remote
          />
        </template>
      </vxe-table-column>
      <!-- 商户证件类型 -->
      <vxe-table-column>
        <vxe-table-column
          field="certificateType"
          :formatter="formatterCertificateType"
          title="商户证件类型"
          min-width="150"
          sortable
          sort-config.remote
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.certificateType"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in parentData.certificateTypeOptions"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <!-- 银行卡类型 -->
      <vxe-table-column>
        <vxe-table-column
          field="cardType"
          :formatter="formatterCardType"
          title="银行卡类型"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.cardType"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in parentData.cardTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="cardNumber"
          title="银行卡号"
          min-width="200"
          sortable
          sort-config.remote
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.cardNumber"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="status"
          :formatter="
            ({ cellValue }) => formatterField({ cellValue }, 'status')
          "
          title="商户状态"
          min-width="130"
          sortable
          sort-config.remote
        />
        <template v-slot:header>
          <el-select v-model="listQuery.status" clearable placeholder="请选择">
            <el-option
              v-for="item in parentData.statusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="failReason"
          title="失败原因"
          min-width="200"
          sortable
          sort-config.remote
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.failReason"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="defaultPlatMer"
          :formatter="
            ({ cellValue }) => formatterField({ cellValue }, 'defaultPlatMer')
          "
          title="默认平台商户"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.defaultPlatMer"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in parentData.defaultPlatMerOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="verifyType"
          :formatter="
            ({ cellValue }) => formatterField({ cellValue }, 'verifyType')
          "
          title="验证方式"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.verifyType"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in parentData.verifyTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="gmtModified"
          title="最后操作时间"
          min-width="420"
          sortable
          sort-config.remote
        />
        <template v-slot:header>
          <el-date-picker
            v-model="gmtModifiedRange"
            type="daterange"
            value-format="yyyy-MM-dd"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtModified')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="modifiedByName"
          title="最后操作人"
          min-width="130"
          sortable
          sort-config.remote
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.modifiedByName"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column title="操作" fixed="right" width="300">
        <template slot-scope="scope">
          <!-- 绑定手机号 -->
          <el-tooltip
            v-if="
              getLimit('MerchantCenter_bind_button') &&
                scope.row.isPhoneBind == 0 &&
                scope.row.status == 3 &&
                scope.row.partyType != 'PLAT_ADMIN_ARPA'
            "
            class="item"
            effect="dark"
            content="绑定手机号"
            placement="top"
          >
            <vxe-button type="text" @click="onShowBindModel(scope.row, 'bind')">
              <i class="el-icon-link" />
            </vxe-button>
          </el-tooltip>
          <!-- 解绑手机号 -->
          <el-tooltip
            v-if="
              getLimit('MerchantCenter_unbind_button') &&
                scope.row.isPhoneBind == 1 &&
                scope.row.status == 3 &&
                scope.row.partyType != 'PLAT_ADMIN_ARPA'
            "
            class="item"
            effect="dark"
            content="解绑手机号"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="onShowBindModel(scope.row, 'unbind')"
            >
              <i class="el-icon-paperclip" />
            </vxe-button>
          </el-tooltip>
          <!-- 提现协议签约 -->
          <el-tooltip
            v-if="
              getLimit('MerchantCenter_signing_button') &&
                scope.row.isSignProtocol == 0 &&
                scope.row.status == 3 &&
                scope.row.partyType != 'PLAT_ADMIN_ARPA'
            "
            class="item"
            effect="dark"
            content="提现协议签约"
            placement="top"
          >
            <vxe-button type="text" @click="onSignContract(scope.row)">
              <i class="el-icon-s-opportunity" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              getLimit('MerchantCenter_edit_button') &&
                (scope.row.status == 0 ||
                  scope.row.status == 3 ||
                  scope.row.status == 4 ||
                  scope.row.status == 6) &&
                scope.row.partyType != 'PLAT_ADMIN_ARPA'
            "
            class="item"
            effect="dark"
            content="编辑"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="onShowModel(scope.row.code, 'Edit')"
            >
              <i class="el-icon-edit" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="getLimit('MerchantCenter_document_button')"
            class="item"
            effect="dark"
            content="详情"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="onShowModel(scope.row.code, 'Detail')"
            >
              <i class="el-icon-document" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              getLimit('MerchantCenter_register_button') &&
                (scope.row.status == 0 || scope.row.status == 4)
            "
            class="item"
            effect="dark"
            content="注册商户"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="registeredMerchant(scope.row.code, scope.row.partyCode)"
            >
              <i class="el-icon-document-add" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              getLimit('MerchantCenter_updata_register_button') &&
                (scope.row.status == 1 || scope.row.status == 6)
            "
            class="item"
            effect="dark"
            content="更新商户注册结果"
            placement="top"
          >
            <vxe-button type="text" @click="Toupdate(scope.row.code)">
              <i class="el-icon-refresh" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              getLimit('MerchantCenter_balance_button') && scope.row.status == 3
            "
            class="item"
            effect="dark"
            content="查询余额"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="CheckBalance(scope.row.code, scope.row.partyCode)"
            >
              <i class="el-icon-search" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              getLimit('MerchantCenter_wallet_button') && scope.row.status == 3
            "
            class="item"
            effect="dark"
            content="查询钱包信息"
            placement="top"
          >
            <vxe-button type="text" @click="accountClick(scope.row.code)">
              <i class="el-icon-folder-checked" />
            </vxe-button>
          </el-tooltip>
          <!-- 绑卡操作-->
          <el-tooltip
            v-if="
              scope.row.status == 3 && scope.row.partyType != 'PLAT_ADMIN_ARPA'
            "
            class="item"
            effect="dark"
            content="绑卡详情"
            placement="top"
          >
            <vxe-button type="text" @click="bindCard(scope.row.partyCode)">
              <i class="el-icon-bank-card" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              getLimit('MerchantCenter_delete_button') &&
                (scope.row.status == 0 || scope.row.status == 4)
            "
            class="item"
            effect="dark"
            content="删除"
            placement="top"
          >
            <vxe-button type="text" @click="funcDelete(scope.row.code)">
              <em class="el-icon-delete" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              getLimit('MerchantCenter_defaultPlatMer_button') &&
                scope.row.partyType === 'PLAT_ADMIN' &&
                scope.row.defaultPlatMer === 0 &&
                scope.row.status === 3
            "
            class="item"
            effect="dark"
            content="设置默认平台商户"
            placement="top"
          >
            <vxe-button type="text" @click="funcDefaultPlatMer(scope.row.code)">
              <em class="el-icon-star-on" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :page-sizes="Pagingconf"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <vxe-modal
      v-model="modelEditFlag"
      :title="modalTitle"
      width="1000"
      height="800"
      resize
      destroy-on-close
    >
      <merchantEdit
        ref="EditRef"
        :parent-data="parentData"
        @merchantClose="merchantClose"
      />
    </vxe-modal>
    <!-- 绑卡详情 -->
    <vxe-modal
      v-model="bindFlag"
      title="绑卡详情"
      width="900"
      height="800"
      resize
    >
      <bindCard ref="bindRef" />
    </vxe-modal>
    <!-- 绑定/解绑手机号 -->
    <vxe-modal
      v-model="isBindPhoneModelShow"
      :title="bindPhoneTitle"
      width="600"
      height="400"
      resize
    >
      <bindPhone ref="bindPhoneRef" @hideBindPhoneModel="hideBindPhoneModel" />
    </vxe-modal>
    <vxe-modal
      v-model="newBalance"
      title="余额"
      width="620"
      height="650"
      resize
    >
      <balanceAmount :balance-list="balanceList" @event2="receive" />
    </vxe-modal>

    <el-drawer title="钱包信息" :visible.sync="accountinfo" direction="rtl">
      <div style="padding-left:20px;">
        <p>
          户名：<span>{{ accountinfoDate.accountName }}</span>
        </p>
        <p>
          收款银行：<span>{{ accountinfoDate.bankName }}</span>
        </p>
        <p>
          收款专用编号：<span>{{ accountinfoDate.bankCardNo }}</span>
        </p>
        <!-- <p>联行号：<span>{{ accountinfoDate.bankCardNo }}</span></p>
        {{ accountinfoDate }} -->
      </div>
    </el-drawer>
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import merchantEdit from "./components/MerchantManagementEdit.vue";
import balanceAmount from "./components/balanceAmount.vue";
import bindCard from "./components/bindCard.vue";
import bindPhone from "./components/bindPhone.vue";
import {
  updateRegisterStatus,
  registerMerchant,
  accountInfo,
  arpaMerchant,
  accountBalance,
  signProtocol
} from "@/api/merchantCenter";
import { getListDict } from "@/api/commonApi";
import request from "@/utils/request";
export default {
  name: "MerchantCenter",
  components: {
    merchantEdit,
    balanceAmount,
    bindCard,
    bindPhone
  },
  data() {
    return {
      partyType: this.$store.getters.party.partyType,
      partyCode: this.$store.getters.party.code,
      showMoney: false,
      bindFlag: false,
      isBindPhoneModelShow: false,
      bindPhoneTitle: "",
      amount: "",
      serviceFeeAmt: "",
      refundAdvanceAmt: "",
      gmtModifiedRange: "",
      allowancesAmt: "",
      platformAvailableAmt: "",
      accountinfoDate: {},
      exportObj: {
        exportUrl: "/ntocc-tms-api/arpaMerchant/exportArpaMerchantList", //导出接口
        name: "商户管理"
      },
      tableData: [],
      balanceList: {},
      parentData: {
        statusOptions: [],
        partyTypeOptions: [],
        merchantTypeOptions: [],
        certificateTypeOptions: [],
        cardTypeOptions: [],
        bankList: []
      },
      modalTitle: "编辑",
      listQuery: {
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0,
        verifyType: "",
        cardType: ""
      },
      newBalance: false,
      modelEditFlag: false,
      branchList: this.$store.state.components.branchList,
      amountFlag: false,
      accountinfo: false
    };
  },
  created() {
    this.getDict();
    this.findList();
    (this.parentData.merchantTypeOptions = [
      {
        value: "1",
        label: "企业商户"
      },
      {
        value: "2",
        label: "个体商户"
      },
      {
        value: "3",
        label: "自然人"
      }
    ]),
      (this.parentData.cardTypeOptions = [
        {
          value: 1,
          label: "基本户"
        },
        {
          value: 2,
          label: "一般户"
        },
        {
          value: 3,
          label: "借记卡"
        }
      ]),
      (this.parentData.verifyTypeOptions = [
        {
          value: 0,
          label: "无需验证"
        },
        {
          value: 1,
          label: "短信验证"
        },
        {
          value: 2,
          label: "打款验证"
        }
      ]),
      (this.parentData.statusOptions = [
        {
          value: 0,
          label: "待注册"
        },
        {
          value: 1,
          label: "审核中"
        },
        {
          value: 2,
          label: "待验证"
        },
        {
          value: 3,
          label: "已完成"
        },
        {
          value: 4,
          label: "已驳回"
        },
        {
          value: 6,
          label: "认证失败"
        }
      ]),
      (this.parentData.partyTypeOptions = [
        {
          value: "DRIVER",
          label: "实际承运人"
        },
        {
          value: "DRIVER_LEADER",
          label: "车队长"
        },

        {
          value: "SHIPMENT",
          label: "个体托运人"
        },
        {
          value: "SHIPMENT_COMPANY",
          label: "企业托运人"
        },
        { label: "平台管理员", value: "PLAT_ADMIN" },
        { label: "通联子户", value: "PLAT_ADMIN_ARPA" }
      ]);
    this.parentData.cardTypeOptions = [
      {
        value: 1,
        label: "基本户"
      },
      {
        value: 2,
        label: "一般户"
      },

      {
        value: 3,
        label: "借记卡"
      }
    ];
    this.parentData.verifyTypeOptions = [
      {
        value: 0,
        label: "无需验证"
      },
      {
        value: 1,
        label: "短信验证"
      },

      {
        value: 2,
        label: "打款验证"
      }
    ];
    this.parentData.defaultPlatMerOptions = [
      {
        value: 0,
        label: "否"
      },
      {
        value: 1,
        label: "是"
      }
    ];
  },
  methods: {
    async findList() {
      this.loading = true;
      let response = await arpaMerchant(this.listQuery, "get");
      this.tableData = response.data.records;
      this.listQuery.total = response.data.total;
      this.loading = false;
    },
    // 查询数据字典
    getDict() {
      // // 获取数据字典： 银行
      getListDict({ types: "bank,certificateType" }).then(response => {
        this.parentData.bankList = response.data.filter(
          item => item.type === "bank"
        )[0]["dictList"];
        this.parentData.certificateTypeOptions = response.data.filter(
          item => item.type === "certificateType"
        )[0]["dictList"];
      });
    },
    formatterCertificateType({ cellValue }) {
      const item = this.parentData.certificateTypeOptions.find(
        item => item.code === cellValue
      );
      return item ? item.name : "";
    },
    formatterCardType({ cellValue }) {
      const item = this.parentData.cardTypeOptions.find(
        item => item.value === cellValue
      );
      return item ? item.label : "";
    },
    formatterVerifyType({ cellValue }) {
      const item = this.parentData.verifyTypeOptions.find(
        item => item.value === cellValue
      );
      return item ? item.label : "";
    },
    //更新商户
    Toupdate(code) {
      const rLoading = this.openLoading();
      updateRegisterStatus({ code }).then(response => {
        rLoading.close();
        this.$message({ message: response.msg, type: "success" });
        this.findList();
      });
    },
    hideBindPhoneModel(tag) {
      this.isBindPhoneModelShow = false;
      if (tag) this.findList();
    },
    //查询余额
    CheckBalance(code, partyCode) {
      const rLoading = this.openLoading();
      accountBalance({ code })
        .then(response => {
          rLoading.close();
          this.balanceList = response.data;
          this.balanceList.partyCode = partyCode;
          this.balanceList.code = code;
          this.newBalance = true;
        })
        .catch(res => {
          this.newBalance = false;
        });
    },
    // 绑卡详情
    bindCard(partyCode) {
      this.bindFlag = true;
      this.$nextTick(() => {
        this.$refs.bindRef.getInfo(partyCode);
      });
    },
    //查询钱包
    accountClick(code) {
      this.accountinfo = true;
      const rLoading = this.openLoading();
      accountInfo(code).then(response => {
        rLoading.close();
        this.accountinfoDate = response.data;
      });
    },
    //注册商户
    registeredMerchant(code) {
      const rLoading = this.openLoading();
      registerMerchant({ code })
        .then(response => {
          this.$message({ message: response.msg, type: "success" });
          this.findList();
        })
        .finally(f => {
          rLoading.close();
          this.findList();
        });
    },
    amountRefClose() {
      this.$refs.amountRef.close();
    },
    // 翻译
    formatterField({ cellValue }, prefix) {
      const item = this.parentData[`${prefix}Options`].find(
        item => item.value === cellValue
      );
      return item ? item.label : "";
    },
    // 提现协议签约
    onSignContract(row) {
      const rLoading = this.openLoading();
      signProtocol({ merchantCode: row.code })
        .then(res => {
          rLoading.close();
          if (res.status === 0) {
            // this.$message.success(res.msg);
            const data = res.data || {};
            if (data.isForward && data.signUrl) {
              window.open(data.signUrl, "_blank");
            } else if (!data.isForward) {
              this.$message.info(res.msg);
              this.findList();
            }
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(err => {
          rLoading.close();
          this.$message.error(err);
        });
    },
    // 绑定/解绑手机号
    onShowBindModel(row, mode) {
      this.bindPhoneTitle = mode === "bind" ? "绑定手机号" : "解绑手机号";
      this.$refs.bindPhoneRef.setDetail({
        mode,
        phone: row.contactPhone,
        code: row.code
      });
      this.isBindPhoneModelShow = true;
    },
    onShowModel(code, prefix) {
      let obj = {
        Edit: "编辑",
        Add: "新增",
        Detail: "详情"
      };
      this.modalTitle = obj[prefix];
      this.$set(this.parentData, "model", prefix);
      this.modelEditFlag = true;
      this.$nextTick(() => {
        this.$refs.EditRef.onReset();
        this.$refs.EditRef.MerchantEditor(code, prefix);
      });
    },
    // 查询
    funcFilter() {
      this.listQuery.pageNum = 1;
      this.findList();
    },
    // 排序
    sortList({ column, property, order }) {
      if (order) {
        this.listQuery.sortField = property;
        this.listQuery.sortType = order;
      } else {
        this.listQuery.sortField = "";
      }
      this.findList();
    },
    // 分页handle
    handlePageChange({ currentPage, pageSize }) {
      this.tableData = [];
      this.listQuery.pageNum = currentPage;
      this.listQuery.pageSize = pageSize;
      this.findList();
    },
    receive(data) {
      this.findList();
      this.newBalance = false;
    },
    merchantClose(tag) {
      if (tag) {
        this.findList();
      }
      this.modelEditFlag = false;
    },
    // 删除方法
    funcDelete(code) {
      this.$confirm("确认删除吗？")
        .then(_ => {
          const rLoading = this.openLoading("正在删除...");
          request({
            url: `/ntocc-tms-api/arpaMerchant`,
            method: "delete",
            params: { code: code }
          }).then(response => {
            this.$message({ message: response.msg, type: "success" });
            rLoading.close();
            this.findList();
          });
        })
        .catch(_ => {});
    },
    // 设置默认平台商户
    funcDefaultPlatMer(code) {
      this.$confirm("确认无正在支付操作时设置，请确认是否设置？")
        .then(_ => {
          const rLoading = this.openLoading("处理中...");
          request({
            url: `/ntocc-tms-api/arpaMerchant/updateDefaultPlatMer`,
            method: "put",
            params: { code: code }
          }).then(response => {
            this.$message({ message: response.msg, type: "success" });
            rLoading.close();
            this.findList();
          });
        })
        .catch(_ => {});
    }
  }
};
</script>

<style lang="scss">
.money-width {
  width: 140px;
  display: inline-block;
}
</style>
